import { readOnlyProperty } from '@lts-web/utils/ObjectUtil';
import SitePropertySchema from '@lts-web/schemas/SitePropertySchema';

class SitePropertyData {
    constructor (data) {
        this._data = Object.freeze(SitePropertySchema(data));
        readOnlyProperty(this, '_data');
    }

    getGroup () {
        return this._data.group;
    }

    getKey () {
        return this._data.key;
    }

    getValue () {
        return this._data.value;
    }
}

export default SitePropertyData;